import React, { useEffect, useState } from "react";
import axios from "axios";
import { messaging } from "../../firebase";
import { getToken } from "firebase/messaging";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const Login = () => {
  const [loginData, setLoginData] = useState({
    Mobile_No: "",
    Password: "",
  });
  const [fcmToken, setFcmToken] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state for the login request
  const [error, setError] = useState(""); // Error state for login failure
  const [fingerprint, setFingerprint] = useState(null);
  const navigate = useNavigate();

  console.log("Finger Print", fingerprint);

  // Function to request notification permission and get FCM token
  const requestPermission = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        const registration = await navigator.serviceWorker.getRegistration();
        if (registration) {
          const token = await getToken(messaging, {
            vapidKey:
              "BD6MYAKEvXKAj2lHEyLBZX2WwPdiqjk4VHICcg57VcF_0xbcjr7Rp0KpWzUVmUkoGONFAxTO8bP2tr0qp0-qC20",
          });
          if (token) {
            console.log("FCM Token Generated:", token);
            setFcmToken(token);
            localStorage.setItem("fcmToken", token);
          } else {
            console.log("No registration token available.");
          }
        } else {
          console.error("No active Service Worker found.");
        }
      } else if (permission === "denied") {
        alert("You denied notifications.");
      }
    } catch (error) {
      console.error("Error getting notification permission or token:", error);
    }
  };

  const loadFingerprint = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    setFingerprint(result.visitorId); 
  };

  useEffect(() => {
    requestPermission();
    loadFingerprint(); 
  }, []);  

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      // Perform login request
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_API}auth/login`,
        loginData
      );
  
      const userData = response.data;
  
    
      localStorage.setItem("LoginUserData", JSON.stringify(userData));
  
      
      const { Token } = userData;
      const existingFootprints = Array.isArray(Token)
        ? Token.map(t => t.FootPrint).filter(Boolean)
        : [];
      
      const isFingerprintMatched = existingFootprints.includes(fingerprint);
      
  
      // console.log("FootPrint from server:", FootPrint);
      console.log("Fingerprint from browser:", fingerprint);
  
      
      if (!isFingerprintMatched) {
        if (existingFootprints.length < 3) {
          // Add new fingerprint to the backend
          await axios.put(
            `${process.env.REACT_APP_SERVER_API}users/${loginData.Mobile_No}/footPrintToken`,
            { FootPrint: fingerprint }
          );
          console.log("New fingerprint added.");
        } else {
          // Deny login if fingerprint does not match and already 3 tokens exist
          alert("Invalid device. You have reached the maximum device limit.");
          setError("Invalid device. You have reached the maximum device limit.");
          setLoading(false);
          return;
        }
      }
  
      const { Role_Id, user_Outlate } = userData;
  
      if (Role_Id == 0) {
        // Navigate to system user dashboard
        navigate("/SystemUserDashboard");
      } else if (Role_Id == 1) {
        if (user_Outlate?.length == 1) {
          // Automatically store and navigate if only 1 outlet
          localStorage.setItem("SelectedOutlet", JSON.stringify(user_Outlate[0]));
          navigate("/LiveTableStatus");
        } else if (user_Outlate?.length > 1) {
          // Navigate to outlet selector page for multiple outlets
          navigate("/selectOutlate");
        } else {
          alert("No outlets assigned to this user.");
        }
      } else if (Role_Id == 3){
        localStorage.setItem("SelectedOutlet", JSON.stringify(user_Outlate[0]));
        navigate("/AccsDashboard");
      } else if (Role_Id == 4) {
        if (user_Outlate?.length === 1) {
          localStorage.setItem("SelectedOutlet", JSON.stringify(user_Outlate[0]));
          navigate("/HoAccDashbord");
        } else if (user_Outlate?.length > 1) {
          navigate("/selectOutlateForHO");
        } else {
          alert("No outlets assigned to this user.");
        }
      }
  
      // Reset form fields
      setLoginData({ Mobile_No: "", Password: "" });
      setError("");
    } catch (error) {
      console.error("Login Failure:", error);
      setError("Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };
  

  
  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="container-fluid mt-5">
      <div className="row d-flex justify-content-center">
        <div className="col-md-4 p-3 mt-5 text-center shadow p-3 mb-5 bg-body rounded">
          <h3>Login</h3>
          <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-danger">{error}</div>}
            <div className="mb-3 mt-4">
              <input
                type="text"
                name="Mobile_No"
                placeholder="Enter Mobile Number"
                className="form-control"
                value={loginData.Mobile_No}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="mb-3 position-relative">
              <input
                type={showPassword ? "text" : "password"}
                name="Password"
                placeholder="Enter Password"
                className="form-control"
                value={loginData.Password}
                onChange={handleInputChange}
                required
              />
              <span
                className="position-absolute end-0 top-50 translate-middle-y me-3"
                style={{ cursor: "pointer" }}
                onClick={togglePasswordVisibility}
              >
                <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
              </span>
            </div>
            <button type="submit" className="btn btn-primary text-center mt-2" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>
            {/* <div className="mt-3 d-flex justify-content-start">
              <p>
                Not a Member? <Link to="/NewRegistration">Register</Link>
              </p>
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
